module.exports = __webpack_public_path__ + "img/logo.cec2592e.png";